import { createContext } from 'react';
import type { CartContextType } from './CartContextType';

export const CartContext = createContext<CartContextType>({
  cart: {},
  setCart: () => {},
  refetchCart: () => {},
  refetchCartWithCurrentIds: () => {},
  showConfirmationMessage: false,
  setShowConfirmationMessage: () => {},
  anonymousId: '',
  setAnonymousId: () => {},
  cartId: '',
  setCartId: () => {},
  guid: '',
  setGuid: () => {},
  isCartLoading: true,
  hasLastItemDeleted: false,
  setHasLastItemDeleted: () => {},
  checkoutSecurely: false,
  setCheckoutSecurely: () => {},
  isCartEmpty: false,
  basketTotal: '0',
  basketTotalCent: 0,
  currency: '',
  itemsInCart: 0,
  isMaxItemsReached: false,
  isBasketValueExceeded: false,
  isMaxItemsReachedOrBasketValueExceeded: () => {},
  isLineItemsEmpty: false,
  isSkuCapReached: false,
  isSkuCapExceeded: false,
  cartInputVariables: undefined,
  shouldUpdateDeliveryOptions: false,
  setShouldUpdateDeliveryOptions: () => {},
  isPopupOpen: false,
  setIsPopupOpen: () => {},
  isQuickBuyOpen: false,
  setIsQuickBuyOpen: () => {},
});
